/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";

class CustomCheckbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_checked: props.isChecked !== undefined ? props.isChecked : !!props.checked,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    const previousChecked =
      prevProps.isChecked !== undefined ? prevProps.isChecked : prevProps.checked;
    const currentChecked =
      this.props.isChecked !== undefined ? this.props.isChecked : this.props.checked;

    if (previousChecked !== currentChecked) {
      this.setState({ is_checked: !!currentChecked });
    }
  }

  handleClick(e) {
    const newCheckedState = !this.state.is_checked;
    this.setState({ is_checked: newCheckedState });

    // Call parent's onChange if provided
    if (this.props.onChange) {
      // Create a synthetic event-like object for consistency
      const syntheticEvent = {
        target: {
          checked: newCheckedState,
          name: this.props.name,
          id: this.props.number,
        },
      };
      this.props.onChange(syntheticEvent);
    }
  }
  render() {
    const { checked, isChecked, number, label, inline, ...rest } = this.props;
    const classes =
      inline !== undefined ? "checkbox checkbox-inline" : "checkbox";
    return (
      <div className={classes}>
        <input
          id={number}
          type="checkbox"
          onChange={this.handleClick}
          checked={this.state.is_checked}
          {...rest}
        />
        <label htmlFor={number}>{label}</label>
      </div>
    );
  }
}

export default CustomCheckbox;
